import { useTranslation } from 'react-i18next';
import { Button, Stack } from '@mui/material';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Stack direction='row' spacing={1}>
      <Button
        size='small'
        onClick={() => changeLanguage('en')}
        color='inherit'
        variant={i18n.resolvedLanguage === 'en' ? 'outlined' : 'text'}
        sx={{ minWidth: '40px', padding: '2px 8px' }}
      >
        EN
      </Button>
      <Button
        size='small'
        onClick={() => changeLanguage('ja')}
        color='inherit'
        variant={i18n.resolvedLanguage === 'ja' ? 'outlined' : 'text'}
        sx={{ minWidth: '40px', padding: '2px 8px' }}
      >
        JA
      </Button>
    </Stack>
  );
};

export default LanguageSwitcher;
